import { allWorks } from "@/lib/content";

interface WorkFiltersProps {
  type: string;
  year: string;
  tag: string;
  sort: string;
  onType: (v: string) => void;
  onYear: (v: string) => void;
  onTag: (v: string) => void;
  onSort: (v: string) => void;
  onReset: () => void;
}

const TYPES = ["全部", "电影", "电视剧"];
const SORTS = [
  { key: "latest", label: "上线时间" },
  { key: "popular", label: "受欢迎度" },
];

export default function WorkFilters({
  type,
  year,
  tag,
  sort,
  onType,
  onYear,
  onTag,
  onSort,
  onReset,
}: WorkFiltersProps) {
  const years = Array.from(new Set(allWorks.map((w) => w.year))).sort((a, b) => b - a);
  const tags = Array.from(new Set(allWorks.flatMap((w) => w.tags)));

  const chip = (active: boolean) =>
    `px-4 h-9 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
      active ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600 hover:bg-background-200"
    }`;

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          {TYPES.map((t) => (
            <button key={t} type="button" onClick={() => onType(t)} className={chip(type === t)}>
              {t}
            </button>
          ))}
        </div>
        <div className="flex items-center gap-1 p-1 rounded-full bg-background-100">
          {SORTS.map((s) => (
            <button
              key={s.key}
              type="button"
              onClick={() => onSort(s.key)}
              className={`px-4 h-8 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                sort === s.key
                  ? "bg-background-50 text-primary-600 border border-primary-300"
                  : "text-foreground-500 hover:text-foreground-800"
              }`}
            >
              {s.label}
            </button>
          ))}
        </div>
      </div>

      <div className="flex items-start gap-3">
        <span className="text-sm text-foreground-400 shrink-0 pt-2">年份</span>
        <div className="flex flex-wrap items-center gap-2">
          <button type="button" onClick={() => onYear("全部")} className={chip(year === "全部")}>
            全部
          </button>
          {years.map((y) => (
            <button key={y} type="button" onClick={() => onYear(String(y))} className={chip(year === String(y))}>
              {y}
            </button>
          ))}
        </div>
      </div>

      <div className="flex items-start gap-3">
        <span className="text-sm text-foreground-400 shrink-0 pt-2">标签</span>
        <div className="flex flex-wrap items-center gap-2">
          <button type="button" onClick={() => onTag("全部")} className={chip(tag === "全部")}>
            全部
          </button>
          {tags.map((t) => (
            <button key={t} type="button" onClick={() => onTag(t)} className={chip(tag === t)}>
              {t}
            </button>
          ))}
        </div>
      </div>

      <button
        type="button"
        onClick={onReset}
        className="self-start text-sm text-foreground-500 hover:text-primary-600 transition-colors flex items-center gap-1 cursor-pointer"
      >
        <i className="ri-refresh-line" />
        重置筛选
      </button>
    </div>
  );
}